import styled from "styled-components";
import { DefaultButton } from "@fluentui/react";

export const ModalContainer = styled.div`
    padding: 24px;
    background-color: ${props => props?.theme?.palette?.white || '#fff'};
`;

export const ModalTitle = styled.h2`
    margin: 0 0 20px 0;
    font-size: 20px;
    font-weight: 600;
    color: ${props => props?.theme?.palette?.neutralPrimary || '#323130'};
    cursor: default;
`;

export const ModalBody = styled.div`
    margin-bottom: 24px;
`;

export const WarningText = styled.p`
    margin: 0 0 20px 0;
    font-size: 16px;
    color: ${props => props?.theme?.palette?.neutralSecondary || '#605e5c'};
    line-height: 1.4;
    cursor: default;
`;

export const CompositionInfo = styled.div`
    border: 1px solid ${props => props?.theme?.palette?.neutralLight || '#edebe9'};
    border-radius: 8px;
    padding: 16px;
    background-color: ${props => props?.theme?.palette?.neutralLighterAlt || '#faf9f8'};
    cursor: default;
`;

export const CompositionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid ${props => props?.theme?.palette?.neutralLight || '#edebe9'};
`;

export const CompositionDate = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: ${props => props?.theme?.palette?.neutralPrimary || '#323130'};
`;

export const FundsCount = styled.div`
    font-size: 14px;
    color: ${props => props?.theme?.palette?.neutralSecondary || '#605e5c'};
    background-color: ${props => props?.theme?.palette?.themePrimary || '#0078d4'};
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-weight: 500;
`;

export const FundsList = styled.div`
    max-height: 200px;
    overflow-y: auto;
    padding-right: 8px;
`;

export const FundItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid ${props => props?.theme?.palette?.neutralLight || '#edebe9'};
    
    &:last-child
    {
        border-bottom: none;
    }
`;

export const FundName = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${props => props?.theme?.palette?.neutralPrimary || '#323130'};
    flex: 1;
    margin-right: 16px;
`;

export const FundDetails = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const FundIsin = styled.div`
    font-size: 12px;
    color: ${props => props?.theme?.palette?.neutralSecondary || '#605e5c'};
    min-width: 120px;
`;

export const FundWeight = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${props => props?.theme?.palette?.themePrimary || '#0078d4'};
    min-width: 60px;
    text-align: right;
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
`;

export const CancelButton = styled(DefaultButton)`
    background-color: transparent !important;
    color: ${props => props?.theme?.palette?.neutralPrimary || '#323130'} !important;
    border: 1px solid ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
    min-width: 80px;
    
    &:hover
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || '#f3f2f1'} !important;
    }

    &:disabled
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || '#f3f2f1'} !important;
        color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        cursor: not-allowed !important;
    }
`;

export const ConfirmButton = styled(DefaultButton)`
    background-color: #d13438 !important;
    color: white !important;
    border: none !important;
    min-width: 80px;
    
    &:hover
    {
        background-color: #a52a2e !important;
    }

    &:disabled
    {
        background-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        color: ${props => props?.theme?.palette?.neutralTertiaryAlt || '#c8c6c4'} !important;
        cursor: not-allowed !important;
        
        &:hover
        {
            background-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        }
    }
`;
